import r from 'restructure';

// only used for encoding
export default new r.Array(new r.Buffer);
